import cssVariable from '../../../../cssExported.module.scss';
import { StripeElementsOptions } from '@stripe/stripe-js';

// This is how we customize Stripe elements appearance
export const stripeElementsOptions: StripeElementsOptions = {
  appearance: {
    variables: {
      colorPrimary: '#0570de',
      colorDanger: cssVariable.error500
    },
    rules: {
      '.Input': {
        lineHeight: '20px',
        padding: '5px',
        fontSize: '14px',
        boxShadow: 'none'
      },
      '.Input--invalid': {
        boxShadow: 'none',
        borderColor: cssVariable.error400
      },
      '.Input--invalid:hover': {
        boxShadow: `${cssVariable.shadowXS}, 0px 0px 0px 4px ${cssVariable.error100}`,
        borderColor: cssVariable.error400
      },
      '.Label': {
        fontSize: '14px'
      }
    }
  }
};
